import i18n from 'i18next'

/** H5 原生定位
 * @desc 必须在https域名下，才可以调用成功
 * @desc IOS用户拒绝获取位置信息，开启方法：1.（设置）Settings -> （通用）Genera -> （重置） Reset-> （重置定位于隐私）Reset Location & Privacy.
 * @desc 2.（设置）Settings ->( 隐私）Privacy -> 开启 Location Services.
 */
export default class H5LocationController {
  static GeoLocation: IGeoLocation = ('geolocation' in navigator) && navigator.geolocation || {} as IGeoLocation
  /** 获取H5的定位信息 */
  static async init (): Promise<ILocation> {
    if ('geolocation' in navigator) {
      const locationRes = await this.getLocation().catch((error: IPositionError) => {
        console.error(`获取地址位置失败：errorCode-${error?.code}`, error)
        console.error(`获取地址位置失败：${error?.PERMISSION_DENIED}-${error?.POSITION_UNAVAILABLE}-${error?.TIMEOUT}-code:${error?.code}-message:${error?.message}`)
        return {
          error: true,
          message: this._getLocationErrorMessage(error)
        }
      }) as TH5LocationRes
      const { coords, error } = locationRes
      console.log('locationRes: ', locationRes)
      if (error) {
        return locationRes as ILocation
      } else {
        return {
          // 7位精确到0.1米；6位精确到1米
          longitude: Number(coords?.longitude ? Number(coords.longitude).toFixed(7) : 0),
          latitude: Number(coords?.latitude ? Number(coords.latitude).toFixed(7) : 0),
        }
      }
    } else { // 地理位置服务不可用
      return {
        error: true,
        errorMsg: i18n.t('location.positionUnavailable')
      }
    }
  }
  /**
   * 获取定位
   * @returns {Promise<IPosition | IPositionError>}
   */
  static getLocation (): Promise<IPosition | IPositionError> {
    return new Promise((resolve, reject) => {
      this.GeoLocation.getCurrentPosition(function (position) {
        resolve(position)
      }, function (error) {
        reject(error)
      }, { timeout: 10000 })
    })
  }
  /**
   * 监听定位
   * @returns {Promise<IPosition | IPositionError>}
   */
  static watchLocation (): Promise<IPosition | IPositionError> {
    return new Promise((resolve, reject) => {
      this.GeoLocation.watchPosition(function (position) {
        resolve(position)
      }, function (error) {
        reject(error)
      })
    })
  }
  /**
   * 清除监听定位
   * @param {number} watchId - 监听定位wacher的Id
   */
  static clearWatch (watchId: number) {
    this.GeoLocation.clearWatch(watchId)
  }
  /**
   * 获取定位错误信息
   * @param {IPositionError} error - 定位错误信息
   * @return {string}
   */
  private static _getLocationErrorMessage (error: IPositionError) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        return i18n.t('location.permissionDenied')
      case error.POSITION_UNAVAILABLE:
        return i18n.t('location.positionUnavailable')
      case error.TIMEOUT:
        return i18n.t('location.timeout')
      default:
        return ''
    }
  }
}
